import FictivSymbol from '~/lib/FictivSymbol'

export const SET_IS_EDIT_PDF_MODE = FictivSymbol('SET_IS_EDIT_PDF_MODE')
export const SET_NEED_BY_DATE_LOADING = FictivSymbol('SET_NEED_BY_DATE_LOADING')
export const SET_NEED_BY_DATE_FAILURE = FictivSymbol('SET_NEED_BY_DATE_FAILURE')
export const SET_QLLT_DATA_LOADING = FictivSymbol('SET_QLLT_DATA_LOADING')
export const SET_QLLT_DATA_FAILURE = FictivSymbol('SET_QLLT_DATA_FAILURE')
export const SET_QLLT_DATA = FictivSymbol('SET_QLLT_DATA')
export const SET_COST_AND_LEAD_TIME_LOADING = FictivSymbol(
    'SET_COST_AND_LEAD_TIME_LOADING',
)
export const SET_COST_AND_LEAD_TIME_FAILURE = FictivSymbol(
    'SET_COST_AND_LEAD_TIME_FAILURE',
)
export const SET_COST_AND_LEAD_TIME = FictivSymbol('SET_COST_AND_LEAD_TIME')
export const SET_ALL_BATCH_POST_PROCESS_LOADING = FictivSymbol(
    'SET_ALL_BATCH_POST_PROCESS_LOADING',
)
export const GET_ALL_BATCH_POST_PROCESS_FAILURE = FictivSymbol(
    'GET_ALL_BATCH_POST_PROCESS_FAILURE',
)
export const GET_ALL_BATCH_POST_PROCESS_QUERY_DATA = FictivSymbol(
    'GET_ALL_BATCH_POST_PROCESS_QUERY_DATA',
)
export const SET_QLLT_CONFIGURE_OPTION = FictivSymbol(
    'SET_QLLT_CONFIGURE_OPTION',
)
export const SET_PROCESS_CONFIG_TO_QMR = FictivSymbol(
    'SET_PROCESS_CONFIG_TO_QMR',
)

export const SET_PROCESS_DETAILS_LOADING = FictivSymbol(
    'SET_PROCESS_DETAILS_LOADING',
)
export const GET_PROCESS_DETAILS_FAILURE = FictivSymbol(
    'GET_PROCESS_DETAILS_FAILURE',
)

export const UPDATE_PROCESS_CONFIG_DATA = FictivSymbol(
    'UPDATE_PROCESS_CONFIG_DATA',
)
export const RESET_OPTIMIZATION = FictivSymbol('RESET_OPTIMIZATION')
export const GET_QLLT_SLACK_THREAD_QUERY_SUCCESS = FictivSymbol(
    'GET_QLLT_SLACK_THREAD_QUERY_SUCCESS',
)
export const GET_QLLT_SLACK_THREAD_QUERY_FAILURE = FictivSymbol(
    'GET_QLLT_SLACK_THREAD_QUERY_FAILURE',
)
export const GET_QLLT_SLACK_THREAD_QUERY_LOADING = FictivSymbol(
    'GET_QLLT_SLACK_THREAD_QUERY_LOADING',
)
export const CREATE_SLACK_THREAD_FAILURE = FictivSymbol(
    'CREATE_SLACK_THREAD_FAILURE',
)
export const CREATE_SLACK_THREAD_LOADING = FictivSymbol(
    'CREATE_SLACK_THREAD_LOADING',
)
export const SET_RECOMMENDED_QUANTITY_TO_REDUCE_LEAD_TIME = FictivSymbol(
    'SET_RECOMMENDED_QUANTITY_TO_REDUCE_LEAD_TIME',
)
export const GET_RECOMMENDED_QUANTITY_TO_REDUCE_LEAD_TIME_FAILURE =
    FictivSymbol('GET_RECOMMENDED_QUANTITY_TO_REDUCE_LEAD_TIME_FAILURE')
export const GET_RECOMMENDED_QUANTITY_TO_REDUCE_LEAD_TIME_LOADING =
    FictivSymbol('GET_RECOMMENDED_QUANTITY_TO_REDUCE_LEAD_TIME_LOADING')
export const REMOVE_ALL_THREADS_LOADING = FictivSymbol(
    'REMOVE_ALL_THREADS_LOADING',
)
export const REMOVE_ALL_THREADS_FAILURE = FictivSymbol(
    'REMOVE_ALL_THREADS_FAILURE',
)

export const BUSINESS_ACCOUNT_FEATURE_QUERY_SUCCESS = FictivSymbol(
    'BUSINESS_ACCOUNT_FEATURE_SUCCESS',
)
export const BUSINESS_ACCOUNT_FEATURE_QUERY_FAILURE = FictivSymbol(
    'BUSINESS_ACCOUNT_FEATURE_FAILURE',
)
export const BUSINESS_ACCOUNT_FEATURE_QUERY_LOADING = FictivSymbol(
    'BUSINESS_ACCOUNT_FEATURE_LOADING',
)

export const SET_BUSINESS_ACCOUNT_FEATURE_LOADING = FictivSymbol(
    'SET_BUSINESS_ACCOUNT_FEATURE_LOADING',
)
export const SET_BUSINESS_ACCOUNT_FEATURE_FAILURE = FictivSymbol(
    'SET_BUSINESS_ACCOUNT_FEATURE_FAILURE',
)

export const SET_LAST_ACTION_PERFORMED = FictivSymbol(
    'SET_LAST_ACTION_PERFORMED',
)

export const RESET_LAST_ACTION_PERFORMED = FictivSymbol(
    'RESET_LAST_ACTION_PERFORMED',
)

export const SET_3D_MODE = FictivSymbol('SET_3D_MODE')

export const SET_QLLT_SELECTED_OPTION = FictivSymbol('SET_QLLT_SELECTED_OPTION')
